
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.5 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#20AA46","d":"M0 0h22.5v5H0V0z"}}),_c('path',{attrs:{"fill":"#E92F3B","d":"M0 10h22.5v5H0v-5z"}}),_c('path',{attrs:{"fill":"#FADF50","d":"M0 5h22.5v5H0V5z"}}),_c('circle',{attrs:{"fill":"#205CCA","cx":"11.3","cy":"7.5","r":"5.2"}}),_c('path',{attrs:{"fill":"#FFDB3D","d":"M11.2 9.2L8.8 11l.9-2.9-2.4-1.8h3l1-2.8 1 2.9h3l-2.4 1.8.9 2.9-2.6-1.9zm0-1l.9.6-.3-1.1.9-.7h-1.1l-.4-1.1-.4 1.1H9.7l.9.7-.3 1.1c0 .1.9-.6.9-.6z"}})])
          )
        }
      }
    